"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const xml_node_1 = require("../xml-node");
class LogoNode extends xml_node_1.XMLNode {
    constructor(node) {
        super(node);
    }
    open(bufferBuilder) {
        if (!this.attributes.kc1 ||
            !this.attributes.kc2) {
            return;
        }
        const kc1 = Number(this.attributes.kc1);
        const kc2 = Number(this.attributes.kc2);
        if (isNaN(kc1) || isNaN(kc2)) {
            return;
        }
        const scaleWidth = this.attributes.scaleWidth === 1 || this.attributes.scaleWidth === 2
            ? this.attributes.scaleWidth
            : 0x01;
        const scaleHeight = this.attributes.scaleHeight === 1 || this.attributes.scaleHeight === 2
            ? this.attributes.scaleHeight
            : 0x01;
        return bufferBuilder.printLogo(kc1, kc2, scaleWidth, scaleHeight);
    }
    close(bufferBuilder) {
        return bufferBuilder;
    }
}
exports.default = LogoNode;
